import React, { useState } from "react";

const ClientsSection = () => {
  const [hoveredLogo, setHoveredLogo] = useState(null);

  const clients = [
    {
      id: 1,
      name: "$LOFI",
      athMarketCap: "$221.3M",
      coinMarketCapUrl: "https://coinmarketcap.com/currencies/lofitheyeti/",
      logoUrl: "https://customer-assets.emergentagent.com/job_telegram-crypto-4/artifacts/3ghdqqak_LOFI.png"
    },
    {
      id: 3,
      name: "$AXOL",
      athMarketCap: "$72.93M",
      coinMarketCapUrl: "https://coinmarketcap.com/currencies/axol/",
      logoUrl: "https://customer-assets.emergentagent.com/job_telegram-crypto-4/artifacts/ovf5wfvo_AXOL.jpeg"
    },
    {
      id: 5,
      name: "$MAWA",
      athMarketCap: "$13.5M",
      coinMarketCapUrl: "https://coinmarketcap.com/currencies/kumala-herris/",
      logoUrl: "https://customer-assets.emergentagent.com/job_telegram-crypto-4/artifacts/k31h2inf_MAWA.jpeg"
    },
    {
      id: 6,
      name: "$BABYTRUMP",
      athMarketCap: "$9.35M", 
      coinMarketCapUrl: "https://coinmarketcap.com/currencies/baby-trump-bnb/",
      logoUrl: "https://customer-assets.emergentagent.com/job_telegram-crypto-4/artifacts/l9hzrfje_BABYTRUMP.jpeg"
    },
    {
      id: 7,
      name: "$ARMY",
      athMarketCap: "$4.78M",
      coinMarketCapUrl: "https://coinmarketcap.com/currencies/army-pump/",
      logoUrl: "https://customer-assets.emergentagent.com/job_telegram-crypto-4/artifacts/rj45xtpw_ARMY.jpeg"
    }
  ];

  return (
    <section id="clients" className="py-14 px-4 min-h-screen flex flex-col justify-center">
      <div className="max-w-7xl mx-auto w-full">
        <div className="text-center mb-16">
          <h2 className="display-large mb-6">Satisfied Clients</h2>
          <p className="body-large">
            Trusted by successful crypto projects for our expertise in building their Telegram communities.
          </p>
        </div>

        <div className="relative h-96 overflow-visible mx-auto" style={{ maxWidth: '800px' }}>
          {clients.map((client, index) => (
            <div
              key={client.id}
              className="absolute cursor-pointer dark-transition"
              style={{
                left: `${10 + (index * 18)}%`,
                top: `${25 + (index % 2) * 30}%`,
                animation: hoveredLogo === client.id ? 'none' : `float${(index % 5) + 1} 4s ease-in-out infinite`,
                animationDelay: `${index * 0.5}s`
              }}
              onMouseEnter={() => setHoveredLogo(client.id)}
              onMouseLeave={() => setHoveredLogo(null)}
            >
              <div className="relative">
                <div 
                  className="w-24 h-24 rounded-full overflow-hidden border-2 border-gray-600 hover:border-cyan-400 transition-colors duration-300"
                  style={{ background: 'var(--bg-secondary)' }}
                >
                  <img 
                    src={client.logoUrl} 
                    alt={client.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                
                {hoveredLogo === client.id && (
                  <div 
                    className="absolute bg-black border border-gray-600 rounded-lg p-4 min-w-max z-50 shadow-2xl"
                    style={{
                      top: index % 2 === 1 ? '-120px' : '90px', // Position above for bottom row, below for top row
                      left: '50%',
                      transform: 'translateX(-50%)',
                      maxWidth: '250px'
                    }}
                    onMouseEnter={() => setHoveredLogo(client.id)} // Keep visible when hovering over tooltip
                    onMouseLeave={() => setHoveredLogo(null)}
                  >
                    <h4 className="heading-3 mb-2">{client.name}</h4>
                    <p className="body-medium mb-2" style={{ color: 'var(--brand-primary)' }}>
                      ATH: {client.athMarketCap}
                    </p>
                    <a 
                      href={client.coinMarketCapUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="body-small hover:underline cursor-pointer"
                      style={{ color: 'var(--brand-primary)' }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      View on CoinMarketCap
                    </a>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Add CSS animations for floating effect */}
        <style jsx>{`
          @keyframes float1 {
            0%, 100% { transform: translateY(0px) translateX(0px); }
            25% { transform: translateY(-10px) translateX(5px); }
            50% { transform: translateY(-5px) translateX(-3px); }
            75% { transform: translateY(-15px) translateX(2px); }
          }
          @keyframes float2 {
            0%, 100% { transform: translateY(0px) translateX(0px); }
            25% { transform: translateY(-15px) translateX(-4px); }
            50% { transform: translateY(-8px) translateX(6px); }
            75% { transform: translateY(-12px) translateX(-2px); }
          }
          @keyframes float3 {
            0%, 100% { transform: translateY(0px) translateX(0px); }
            25% { transform: translateY(-8px) translateX(3px); }
            50% { transform: translateY(-18px) translateX(-5px); }
            75% { transform: translateY(-6px) translateX(4px); }
          }
          @keyframes float4 {
            0%, 100% { transform: translateY(0px) translateX(0px); }
            25% { transform: translateY(-12px) translateX(-3px); }
            50% { transform: translateY(-4px) translateX(5px); }
            75% { transform: translateY(-16px) translateX(-1px); }
          }
          @keyframes float5 {
            0%, 100% { transform: translateY(0px) translateX(0px); }
            25% { transform: translateY(-6px) translateX(4px); }
            50% { transform: translateY(-14px) translateX(-2px); }
            75% { transform: translateY(-9px) translateX(3px); }
          }
        `}</style>
      </div>
    </section>
  );
};

export default ClientsSection;